import { Button } from '@talentmesh/ui/components/button';
import { Dialog, DialogContent, DialogTitle, DialogFooter } from '@talentmesh/ui/components/dialog';
import { TypographyP } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

interface FailedToGenerateJobAdDialogProps {
    dialogTitle: string;
    message1: string;
    message2?: string;
    open: boolean;
    close: () => void;
}

function FailedToGenerateJobAdDialog({
    dialogTitle,
    message1,
    message2,
    open,
    close,
}: FailedToGenerateJobAdDialogProps) {
    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && close()}>
            <DialogContent className="max-w-md" showCloseButton={false}>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <div className="flex flex-col gap-4">
                    <TypographyP className="whitespace-pre-line">{message1}</TypographyP>
                    {message2 && <TypographyP>{message2}</TypographyP>}
                </div>
                <DialogFooter className="justify-center sm:justify-center">
                    <Button onClick={close}>{UIStrings.IUnderstand}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default FailedToGenerateJobAdDialog;
